<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithCancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ modalTitle }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <lib-deca-list-item
          [document]="document"
          [userCompanyId]="userCompanyId"
        ></lib-deca-list-item>
      </ion-col>
      <ion-col
        size="12"
        sizeMd="6"
      >
        <ion-button
          expand="block"
          fill="solid"
          (click)="openAddressbookModal()"
        >
          <ion-icon
            slot="start"
            src="../assets/material-symbols/search_24dp.svg"
          ></ion-icon>
          Buscar en libreta de direcciones
        </ion-button>
      </ion-col>
      <ion-col
        size="12"
        sizeMd="6"
      >
        <ion-button
          expand="block"
          fill="outline"
          (click)="openPostalCodeModal()"
        >
          <ion-icon
            slot="start"
            src="../assets/material-symbols/pin_drop_24dp.svg"
          ></ion-icon>
          Nueva dirección
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>

  <form
    [formGroup]="form"
    (ngSubmit)="saveChanges()"
  >
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <ion-input
            type="text"
            formControlName="companyName"
            label="Nombre o empresa"
            labelPlacement="floating"
            placeholder="Introduce el nombre del remitente o destinatario"
            fill="outline"
            mode="md"
            [clearInput]="true"
            [errorText]="form.controls.companyName.hasError('required') ? 'El nombre es obligatorio' : ''"
          ></ion-input>
        </ion-col>

        <ion-col size="12">
          <ion-input
            type="text"
            formControlName="street"
            label="Línea de dirección (Calle, número, polígono...)"
            labelPlacement="floating"
            placeholder="Ej: Calle Mayor, 15, Polígono Industrial..."
            fill="outline"
            mode="md"
            [clearInput]="true"
            [errorText]="form.controls.street.hasError('required') ? 'La dirección es obligatoria' : ''"
          ></ion-input>
        </ion-col>
        <ion-col size="12">
          @let location = locationData();
          @if (location && location.postalCode) {
            <p>
              ({{ location.postalCode }}) {{ location.city }},
              {{ 'states.' + location.countryCode + location.stateCode | translate }},
              {{ 'countries.' + location.countryCode | translate }}
            </p>
          }
        </ion-col>
        <ion-col size="12">
          @if (isServiceStarted) {
            <lib-deca-edit-reason [form]="form.controls.changeReason"></lib-deca-edit-reason>
          }
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="saveChanges()"
            color="primary"
            expand="block"
            fill="solid"
            size="large"
          >
            Guardar cambios
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
